import React from 'react';

import { LoadingWrapperWithFailure } from '@nw/shared/ui';

import { UseUserAuthHandlerMachineReturnType } from '../../hooks/useUserAuthHandlerMachine';
import {
  UserAuthHandlerMachineSendType,
  UserAuthHandlerMachineStateType
} from '../../types/UserAuthHandlerMachineTypes';

import withUserAuthHandlerMachine from './WithUserAuthHandlerMachine';

import './index.scss';

import { ClientBasedAuthPageUI } from '../../components/ClientBasedAuthPageUI';

interface Props {
  userAuthHandlerMachineSend: UserAuthHandlerMachineSendType;
  userAuthHandlerMachineState: UserAuthHandlerMachineStateType;
  status: UseUserAuthHandlerMachineReturnType['status'];
  errors: UseUserAuthHandlerMachineReturnType['errors'];
  onSuccessfulLogin: (
    userAuthHandlerMachineState: UserAuthHandlerMachineStateType,
    shouldRedirectToProfilePage: boolean
  ) => void;
  onFailedLogin: () => void;
}

class UserAuthHandlerRoute extends React.Component<Props> {
  renderClientBaseAuthPage = () => {
    const { userAuthHandlerMachineState, userAuthHandlerMachineSend } =
      this.props;
    const { isLoggedIn } = this.props.userAuthHandlerMachineState.context;
    if (isLoggedIn) {
      const shouldRedirectToProfilePage =
        userAuthHandlerMachineState.context.shouldRedirectToProfilePage;
      this.props.onSuccessfulLogin(
        userAuthHandlerMachineState,
        shouldRedirectToProfilePage
      );
    }
    const { clientConfigDetails } = userAuthHandlerMachineState.context;
    return (
      clientConfigDetails && (
        <ClientBasedAuthPageUI
          userAuthHandlerMachineState={userAuthHandlerMachineState}
          userAuthHandlerMachineSend={userAuthHandlerMachineSend}
          clientConfigDetails={clientConfigDetails}
        />
      )
    );
  };

  renderFailureUI = () => {
    this.props.onFailedLogin();
    return null;
  };

  override render() {
    const { status, errors } = this.props;
    return (
      <LoadingWrapperWithFailure
        renderSuccessUI={this.renderClientBaseAuthPage}
        renderFailureUI={this.renderFailureUI}
        onRetry={() => window.location.reload()}
        apiStatus={status.clientConfigDetailsApiStatus}
        apiError={errors.clientConfigDetailsApiError}
      />
    );
  }
}
const UserAuthHandlerRouteWithMachine =
  withUserAuthHandlerMachine(UserAuthHandlerRoute);

export {
  UserAuthHandlerRouteWithMachine as UserAuthHandlerRoute,
  withUserAuthHandlerMachine
};
